export enum TRIGGERS {
  'leads-count' = 'leads-count',
  connect = 'connect',
  disconnect = 'disconnect',
}
